// Youvex video seridi: ortadaki (telefondaki) video sessiz otomatik oynar,
// kaydirinca yeni ortadaki oynar, digerleri durur. Telefona tiklamak durdurur/surdurur.
document.querySelectorAll('[data-yv-vr]').forEach((viewport) => {
  const rail = viewport.querySelector('[data-yv-vr-rail]');
  const items = [...viewport.querySelectorAll('[data-yv-vr-item]')];
  const dotsBox = viewport.parentElement.querySelector('[data-yv-vr-dots]');
  if (!rail || items.length === 0) return;

  const videos = items.map((item) => item.querySelector('[data-yv-vr-video]'));
  const START = Math.min(1, items.length - 1); // 2. videodan basla
  let current = START;
  let interacted = false;
  let inView = false;

  /** Serit ortasina en yakin ogenin sirasi. */
  const activeIndex = () => {
    const center = rail.scrollLeft + rail.clientWidth / 2;
    let best = 0;
    let bestDistance = Infinity;
    items.forEach((item, i) => {
      const distance = Math.abs(item.offsetLeft + item.offsetWidth / 2 - center);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = i;
      }
    });
    return best;
  };

  const dots = items.map((_, i) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'yv-vr__dot';
    dot.setAttribute('role', 'tab');
    dot.setAttribute('aria-label', `${i + 1}. video`);
    dot.addEventListener('click', () => {
      interacted = true;
      scrollToIndex(i);
    });
    dotsBox?.append(dot);
    return dot;
  });

  function scrollToIndex(i, behavior = 'smooth') {
    const item = items[i];
    rail.scrollTo({
      left: item.offsetLeft + item.offsetWidth / 2 - rail.clientWidth / 2,
      behavior,
    });
  }

  // — oynatma: sadece ortadaki video, sessiz —
  function playActive() {
    videos.forEach((video, i) => {
      if (!video) return;
      if (i === current && inView) {
        video.muted = true;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }

  function sync() {
    const index = activeIndex();
    const changed = index !== current;
    current = index;
    items.forEach((item, i) => item.classList.toggle('is-active', i === index));
    dots.forEach((dot, i) => dot.setAttribute('aria-selected', String(i === index)));
    if (changed) playActive();
  }

  let frame;
  rail.addEventListener('scroll', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(sync);
  });

  // Telefondaki videoya tiklamak durdurur/surdurur; yandakine tiklamak onu ortaya getirir.
  // Karar basma anindaki duruma gore verilir: tarayici dugmeyi odaklarken seridi
  // kaydirabiliyor, tiklama geldiginde yandaki video coktan ortaya gelmis oluyor.
  viewport.querySelectorAll('[data-yv-vr-play]').forEach((button) => {
    const index = items.indexOf(button.closest('[data-yv-vr-item]'));
    const video = videos[index];
    let wasActive = false;
    button.addEventListener('pointerdown', () => { wasActive = index === current; });
    button.addEventListener('click', () => {
      interacted = true;
      if (!wasActive) {
        scrollToIndex(index);
        return;
      }
      if (!video) return;
      if (video.paused) {
        video.muted = true;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  });

  videos.forEach((video) => {
    if (!video) return;
    const media = video.closest('.yv-vr__media');
    video.addEventListener('pause', () => media.classList.remove('is-playing'));
    video.addEventListener('play', () => media.classList.add('is-playing'));
  });

  // Ekranda degilken oynatma; ekrana girince ortadakini baslat.
  new IntersectionObserver(
    ([entry]) => {
      inView = entry.isIntersecting;
      playActive();
    },
    { threshold: 0.25 },
  ).observe(viewport);

  // — fareyle surukleme (dokunmatik kaydirmayi tarayici zaten yapiyor) —
  let dragging = false;
  let startX = 0;
  let startScroll = 0;
  let moved = 0;

  rail.addEventListener('pointerdown', (event) => {
    interacted = true;
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    dragging = true;
    moved = 0;
    startX = event.clientX;
    startScroll = rail.scrollLeft;
  });

  rail.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    const delta = event.clientX - startX;
    moved = Math.max(moved, Math.abs(delta));
    // Sinif ancak gercekten surukleyince eklenir; duz tiklama dugmeye ulassin.
    if (moved > 6) rail.classList.add('is-dragging');
    rail.scrollLeft = startScroll - delta;
    event.preventDefault();
  });

  const endDrag = () => {
    if (!dragging) return;
    dragging = false;
    if (!rail.classList.contains('is-dragging')) return;
    rail.classList.remove('is-dragging');
    // Birakinca en yakin ogeye otur.
    scrollToIndex(activeIndex());
  };

  rail.addEventListener('pointerup', endDrag);
  rail.addEventListener('pointercancel', endDrag);
  rail.addEventListener('pointerleave', endDrag);
  // Surukleme sonrasi tiklama videoyu durdurmasin.
  rail.addEventListener('click', (event) => {
    if (moved > 6) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  // — baslangic —
  // Stil dosyasi gec gelirse olcumler yanlis olur; sayfa yuklenince kullanici
  // dokunmadiysa yeniden ortala. Pencere boyutu degisince secili olani koru.
  const start = () => {
    if (interacted) return;
    scrollToIndex(START, 'auto');
    sync();
  };
  start();
  window.addEventListener('load', start, { once: true });
  window.addEventListener('resize', () => scrollToIndex(current, 'auto'));
});
